import React, { useEffect, useState } from 'react';
import { useConnector } from 'react-instantsearch-hooks-web';
import connectRange from 'instantsearch.js/es/connectors/range/connectRange';
import { RangeSlider, RangeSliderRange, RangeSliderThumb, RangeSliderTrack } from '@components/parts';
import { useMount, useUpdateEffect } from 'ahooks';

let styles = {};
let widgetStyles = {};

export function useRangeSlider(props) {
  return useConnector(connectRange, props);
}

export const RangeInput = (props) => {
  const [value, setValue] = useState();
  const { start, range, canRefine, refine, sendEvent } = useRangeSlider(props);

  const handleUpdate = (newValues) => {
    if (newValues.every((element) => !isNaN(element))) {
      setValue(newValues);
      refine(newValues);
    }
  };

  useUpdateEffect(() => {
    setValue([range.min, range.max]);
    refine([]);
  }, [range.min, range.max]);

  if (!canRefine) {
    return null;
  }

  if (range.max - range.min < 6) {
    refine([]);
    return null;
  }

  return (
    <div className="ais-RefinementRange" data-type={props.attribute}>
      <header>Price</header>
      <div className="content">
        <RangeSlider
          // step={Math.min(Math.floor((range.max - range.min) / 20), 1)}
          min={range.min}
          max={range.max}
          minStepsBetweenThumbs={2}
          value={value ? value : [range.min, range.max]}
          onValueChange={handleUpdate}
        >
          <RangeSliderTrack>
            <RangeSliderRange></RangeSliderRange>
          </RangeSliderTrack>
          <RangeSliderThumb className="thumb"></RangeSliderThumb>
          <RangeSliderThumb className="thumb"></RangeSliderThumb>
        </RangeSlider>
        {value && (
          <div className={`price-range ${(styles.currentRefinement, widgetStyles.currentRefinement)}`}>
            From ${value ? Math.max(range.min, value[0]) : range.min} to ${value ? Math.min(range.max, value[1]) : range.max}
          </div>
        )}
      </div>
    </div>
  );
};
